export const $BODY = 'body';
export const $HEADER = '#header--main';
export const $NAVBAR = '#nav-bar--desktop';
export const $NAVBAR_MOBILE = '#nav-bar--mobile';
export const $CONTENT_WINDOW = '#content-pane-scroller';
export const $CONTENT_PANE = '#content-pane';
export const $CONTENT_BODY = '#page-content';
export const $SITE_MESSAGE_BAR = '.js-site-message-bar';
